<div class="pb-2">
  <div class="mt-4 d-flex pe-3 justify-content-end gap-2">
    <!-- Add documents -->
    <button class="btn btn-primary-dark btn-sm text-xxs shadow" data-bs-toggle="modal"
      data-bs-target="#upload_additional_documents_modal">
      Add documents
    </button>
 
    <!-- Request Information -->
    <button v-if="has_unverified_documents" class="btn btn-primary-dark btn-sm text-xxs shadow" data-bs-toggle="modal"
      data-bs-target="#request_information" @click="open_request_modal">
      Request Information
    </button>
  </div>
</div>
 
<div class="glassy-bg p-3 rounded-lg shadow-sm">
  <div v-if="table_safe_documents.length > 0" class="table-responsive text-xxs">
    <table class="table table-hover" id="document_management_table">
      <thead class="custom-header">
        <tr>
          <th class="text-uppercase text-xs font-weight-bolder opacity-7 text-start ps-3">NO</th>
          <th class="text-uppercase text-xs font-weight-bolder opacity-7 text-start ps-3">Document Name</th>
          <th class="text-uppercase text-xs font-weight-bolder opacity-7 text-start ps-3">Section Name</th>
          <th class="text-uppercase text-xs font-weight-bolder opacity-7 text-start ps-3">Date Uploaded</th>
          <th class="text-uppercase text-xs font-weight-bolder opacity-7 text-start ps-3">Status</th>
          <th class="text-uppercase text-xs font-weight-bolder opacity-7 text-start ps-3">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, index) in table_safe_documents" :key="index">
          <td class="text-xs text-start">{{ index + 1 }}</td>
          <td class="text-xxs text-start">{{ row.file_name }}</td>
          <td class="text-xxs text-start">{{ row.section }}</td>
          <td class="text-xxs text-start">{{ format_date(row.submitted_on) }}</td>
          <td class="text-xxs">
            <span v-if="row.is_verified" class="badge bg-success text-white">Manually Verified</span>
            <span v-else class="badge bg-danger text-white">Pending Verification</span>
          </td>
          <td class="d-flex flex-nowrap gap-2 align-items-center">
            <button class="btn btn-primary-dark btn-sm text-xxs shadow me-1" @click="preview_file(row.presigned_url)">
              Preview
            </button>
 
            <button v-if="!row.is_verified" class="btn btn-primary-dark btn-sm text-xxs shadow"
              @click="verify_document(row)">
              Manually Verify
            </button>
          </td>
        </tr>
      </tbody>
    </table>
 
  </div>
  <div v-else class="p-4 text-center text-muted">
    No documents available.
  </div>
</div>
 
<div v-if="preview_modal" @click.self="preview_modal = false">
  <FilePreviewComponent :presigned_url="preview_url" @close="close_the_file_preview" :key="preview_url" />
</div>
 
<teleport to="body">
  <div class="modal fade" id="request_information" tabindex="-1" aria-labelledby="request_information_label"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
        <div class="modal-header border-bottom-0 cute-header shadow-lg">
          <p class="modal-title text-white text-xxs" id="request_information_label">Request Information</p>
          <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <!-- Current section's answered files -->
          <div v-if="answered_file_questions.length > 0" class="mb-3">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <p class="text-xxs fw-bold mb-0">Files in current section:</p>
            </div>
            <div class="mt-3">
              <div v-for="question in answered_file_questions" :key="question.id" class="file-list-item">
                <div class="d-flex justify-content-between align-items-center">
                  <div class="d-flex align-items-center">
                    <i class="bi bi-file-earmark me-2 text-primary"></i>
                    <div>
                      <div class="text-xxs">{{ question.question_text }}</div>
                    </div>
                  </div>
                  <input type="checkbox" :value="question.section_question_id"
                    :data-requested_field_text="question.question_text" class="form-check-input ms-3"
                    @change="toggle_requested_field($event, question)" />
                </div>
              </div>
            </div>
          </div>
 
          <div class="modal-form-group form-group mb-2 d-flex flex-column">
            <label for="request_info_note" class="modal-form-label form-label text-start text-xxs">Notes</label>
            <textarea v-model="request_info_note" id="request_info_note"
              class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm" rows="4">
          </textarea>
          </div>
        </div>
        <div class="modal-footer border-0 p-2 d-flex justify-content-end">
          <button type="button" class="btn btn-primary-dark btn-sm text-xxs shadow"
            @click="request_information">Request</button>
        </div>
      </div>
    </div>
  </div>
</teleport>
 
<teleport to="body">
  <div class="modal fade" id="upload_additional_documents_modal" tabindex="-1"
    aria-labelledby="upload_additional_documents_modal_label" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content border-0 shadow-lg">
        <!-- Header -->
        <div class="modal-header cute-header d-flex align-items-center justify-content-between px-3 py-2">
          <h5 class="modal-title text-white text-xs m-0" id="upload_additional_documents_modal_label">
            Upload additional documents
          </h5>
          <button type="button" class="btn-close modal-btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
 
        <!-- Body -->
        <div class="modal-body p-4">
          <form @submit.prevent="upload_additional_documents">
            <!-- Journal Attachments -->
            <div class="form-group mb-3">
              <div class="d-flex justify-content-end align-items-center mb-2">
                <button type="button" class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
                  @click="add_attachment">
                  <i class="fas fa-plus"></i>
                </button>
              </div>
 
              <!-- Dynamic Attachments -->
              <div v-for="(attachment, index) in attachments" :key="index"
                class="border rounded p-3 mb-3 position-relative">
                <!-- Remove Button -->
                <button type="button"
                  class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark position-absolute top-0 end-0 m-2"
                  @click="remove_attachment(index)">
                  <i class="bi bi-trash-fill"></i>
                </button>
 
                <!-- Document Name -->
                <div class="mb-2">
                  <label class="text-xxs fw-bold">Document Name</label>
                  <input type="text" v-model="attachment.document_name" class="form-control text-xs mt-1"
                    placeholder="e.g. Affidavit, Supporting Evidence" required />
                </div>
 
                <!-- Upload File -->
                <div>
                  <label class="text-xxs fw-bold">Upload File</label>
                  <input type="file" class="form-control text-xs mt-1" @change="handle_file_upload($event, index)"
                    accept=".pdf,.png,.jpg,.jpeg,.docx" required />
                  <small v-if="attachment.file" class="text-success text-xxs mt-1 d-block">
                    {{ attachment.file.name }}
                  </small>
                </div>
              </div>
 
              <!-- Empty State -->
              <p v-if="attachments.length === 0" class="text-muted text-xxs mt-2 mb-0 fst-italic">
                No attachments added yet. Click <b>+</b> to add your first file.
              </p>
            </div>
 
 
 
            <!-- Submit Button -->
            <div class="d-flex justify-content-end mt-3">
              <button type="submit" class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
                :disabled="is_uploading_documents">
                <span v-if="!is_uploading_documents">Save documents</span>
                <span v-else>Saving...</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</teleport>